export const es = {
  nav: {
    home: 'Inicio',
    about: 'Nosotros',
    programs: 'Oferta Académica',
    admissions: 'Admisiones',
    contact: 'Contacto',
    more: 'Más',
    requestInfo: 'Solicitar Información',
    scheduleVisit: 'Agendar Visita',
  },
  hero: {
    title: 'Aspira a lo más alto con humildad',
    subtitle: 'Alcanza tu máximo potencial mediante la innovación académica, la educación personalizada y la formación integral.',
    ctaInfo: 'Solicitar Información',
    ctaVisit: 'Agendar Visita',
  },
  home: {
    heroBadge: 'SAN LORENZO SCHOOL OF INNOVATION',
    scrollDown: 'Descubre más',
    benefitsBadge: 'Diferenciadores',
    programsBadge: 'Educación Integral',
    galleryBadge: 'Galería',
    ctaTitle: '¿Listo para formar parte de nuestra comunidad?',
    ctaSubtitle: 'Descubre por qué San Lorenzo es la segunda casa de múltiples familias.',
  },
  stats: {
    students: 'Estudiantes',
    years: 'Años de experiencia',
    teachers: 'Maestros calificados',
    languages: 'Idiomas',
  },
  benefits: {
    title: '¿Por qué elegir San Lorenzo School?',
    academic: 'Excelencia Académica',
    academicDesc: 'Programas educativos de alta calidad con resultados sobresalientes en evaluaciones nacionales.',
    bilingual: 'Educación Trilingüe',
    bilingualDesc: 'Inmersión en español, francés e inglés desde preescolar, preparando estudiantes para un mundo globalizado.',
    innovation: 'Tecnología',
    innovationDesc: 'Aulas equipadas con tecnología de punta, laboratorios de computación, programas de robótica y diseño 3D.',
    sports: 'Innovación Curricular',
    sportsDesc: 'Comunica+, Life Skills, educación financiera, investigación y fundamentos de administración.',
    arts: 'Arte y Cultura',
    artsDesc: 'Programas de música, pintura, danza, escultura y artes visuales que fomentan la creatividad y la expresión.',
    values: 'Formación en Valores',
    valuesDesc: 'Énfasis en ética, respeto, responsabilidad, honestidad y servicio comunitario para formar seres humanos integrales.',
  },
  programs: {
    title: 'Programas Académicos',
    subtitle: 'Ofrecemos una educación integral desde preescolar hasta secundaria, diseñada para desarrollar el máximo potencial de cada estudiante.',
    preschool: 'Preescolar',
    preschoolDesc: 'Ambiente seguro y estimulante donde los niños desarrollan habilidades cognitivas, sociales y emocionales a través del juego y la exploración.',
    primary: 'Primaria',
    primaryDesc: 'Formación sólida en áreas fundamentales con metodologías activas que desarrollan el pensamiento crítico y la creatividad.',
    secondary: 'Secundaria',
    secondaryDesc: 'Preparación académica rigurosa con orientación vocacional, proyectos de investigación y desarrollo de liderazgo.',
    methodology: 'Metodología',
    methodologyDesc: 'Aprendizaje Basado en Proyectos, gamificación y metodología STEM.',
    benefits: 'Beneficios',
    activities: 'Actividades y Servicios',
    heroBadge: 'Educación Integral',
    ages: {
      preschool: '2 - 5 años',
      primary: '6 - 11 años',
      secondary: '12 - 17 años',
    },
    preschoolMethodology: [
      'Aprendizaje Basado en Proyectos',
      'Gamificación',
      'STEM para preescolar',
      'Exploración sensorial',
    ],
    preschoolBenefits: [
      'Ambiente seguro y estimulante',
      'Maestros especializados en educación infantil',
      'Grupos reducidos para atención personalizada',
      'Desarrollo integral del niño',
    ],
    preschoolActivities: [
      'Day Care / After School (sin costo adicional)',
      'Clubes extracurriculares',
      'Slow Coffee: Cafetería con 3 tiempos de alimentación (costo adicional)',
    ],
    primaryMethodology: [
      'Aprendizaje Basado en Proyectos',
      'Gamificación',
      'Metodología STEM',
      'Evaluación Trimestral',
    ],
    primaryBenefits: [
      'Formación sólida en áreas fundamentales',
      'Desarrollo del pensamiento lógico-matemático',
      'Educación trilingüe',
      'Habilidades socioemocionales',
    ],
    primaryActivities: [
      'Day Care / After School (sin costo adicional)',
      'Clubes extracurriculares',
      'Slow Coffee: Cafetería con 3 tiempos de alimentación (costo adicional)',
    ],
    secondaryMethodology: [
      'Aprendizaje Basado en Proyectos',
      'Gamificación',
      'Metodología STEM',
      'Evaluación Trimestral',
    ],
    secondaryBenefits: [
      'Preparación para universidades de élite',
      'Innovación Curricular',
      'Formación en valores',
      'Servicio comunitario',
    ],
    secondaryActivities: [
      'Clubes extracurriculares',
      'Slow Coffee: Cafetería con 3 tiempos de alimentación (costo adicional)',
    ],
  },
  news: {
    title: 'Noticias y Eventos',
    subtitle: 'Mantente al día con las últimas novedades, logros y actividades de nuestra comunidad educativa.',
    readMore: 'Leer más',
    allNews: 'Ver todas las noticias',
  },
  gallery: {
    title: 'Nuestra Comunidad',
    subtitle: 'Momentos especiales, logros y actividades que hacen de San Lorenzo School un lugar único.',
  },
  about: {
    title: 'Sobre San Lorenzo School',
    heroBadge: 'Conócenos',
    history: {
      title: 'Magnanimidad',
      desc: 'Maximizar el alma, hacer lo correcto aunque cueste para alcanzar un bien mayor.',
    },
    historyBadge: 'Nuestro Valor Principal',
    mission: {
      title: 'Misión',
      desc: 'Formar personas capaces de pensar, crear, servir y liderar con propósito.'
    },
    vision: {
      title: 'Visión',
      desc: 'Que la persona estudiante descubra y desarrolle su máximo potencial en la ruta hacia la innovación.',
    },
    values: {
      title: 'Nuestros Valores',
      excellence: 'Excelencia',
      integrity: 'Integridad',
      respect: 'Respeto',
      innovation: 'Innovación',
      responsibility: 'Responsabilidad',
      solidarity: 'Solidaridad',
    },
    philosophy: {
      title: 'Pilares del San Lorenzo',
      desc: ['STEM', 'Diseño', 'Innovación', 'Emprendedurismo', 'Habilidades para la vida'],
    },
    philosophyBadge: 'Pilares del San Lorenzo',
    team: {
      title: 'Equipo Directivo y Docente',
      subtitle: 'Profesionales altamente calificados y comprometidos con la educación de excelencia.',
    },
  },
  studentLife: {
    title: 'Vida Estudiantil',
    subtitle: 'Una experiencia educativa completa que va más allá del aula. Descubre las actividades que hacen de San Lorenzo School un lugar especial.',
    sports: {
      title: 'Deportes',
      desc: 'Programas deportivos que incluyen fútbol, baloncesto, voleibol, gimnasia, bádminton y más. Contamos con instalaciones de primer nivel y entrenadores certificados.',
    },
    arts: {
      title: 'Arte y Cultura',
      desc: 'Programas de música, pintura, danza, escultura, artes visuales, telas, danza aérea, ballet y manualidades en porcelana fría que fomentan la creatividad.',
    },
    technology: {
      title: 'Tecnología',
      desc: 'Laboratorios de computación, programas de robótica, desarrollo de apps y preparación para la era digital. Clubs de programación y competencias de ciencia.',
    },
    clubs: {
      title: 'Clubes y Actividades',
      desc: 'Clubes: Catequesis, Mini Chef, Mini Vets. Actividades diseñadas para desarrollar habilidades y pasiones en cada estudiante.',
    },
    service: {
      title: 'Servicios',
      desc: 'Day Care de 6:00 a.m. a 6:00 p.m. sin costo adicional. Slow Coffee disponible con costo adicional.',
    },
    events: {
      title: 'Eventos Institucionales',
      desc: 'Días deportivos, ferias de ciencia, conciertos, graduaciones, ceremonias de premiación y celebraciones culturales que unen a toda la comunidad.',
    },
  },
  admissions: {
    title: 'Proceso de Admisión',
    subtitle: 'Te acompañamos en cada paso para que tu familia forme parte de la comunidad San Lorenzo School.',
    heroBadge: 'Únete a nosotros',
    process: {
      title: 'Proceso de Admisión',
      badge: 'Paso a paso',
      step1: 'Solicitud de Información',
      step1Desc: 'Escríbenos o llámanos por WhatsApp para recibir información detallada sobre nuestros programas.',
      step2: 'Visita Guiada',
      step2Desc: 'Agenda una visita personalizada para conocer nuestras instalaciones, metodología y comunidad educativa.',
      step3: 'Entrevista y Evaluación',
      step3Desc: 'Realizamos una entrevista con la familia y una evaluación académica del estudiante para asegurar la mejor adaptación.',
      step4: 'Matrícula',
      step4Desc: 'Una vez aceptado, completamos el proceso de matrícula con toda la documentación requerida.',
    },
    requirements: {
      title: 'Requisitos',
      badge: 'Documentación',
      item1: 'Formulario de admisión completado',
      item2: 'Copia de cédula de identidad del estudiante',
      item3: 'Certificado de notas del año anterior',
      item4: 'Carta de recomendación del colegio anterior',
      item5: 'Entrevista con los padres de familia',
      item6: 'Evaluación académica del estudiante',
    },
    faq: {
      title: 'Preguntas Frecuentes',
      q1: '¿Cuál es el costo de la matrícula?',
      a1: 'Los costos varían según el nivel educativo. Contáctanos para recibir una cotización personalizada con toda la información de pensiones y servicios incluidos.',
      q2: '¿Aceptan estudiantes durante el año escolar?',
      a2: 'Sí, evaluamos admisiones durante todo el año escolar según disponibilidad de cupos en cada grado.',
      q3: '¿Ofrecen transporte escolar?',
      a3: 'Sí, contamos con servicio de transporte escolar que cubre diferentes zonas de San José y áreas cercanas.',
      q4: '¿Tienen programa de becas?',
      a4: 'Ofrecemos programas de becas académicas y deportivas. Consulta los requisitos y postulación con nuestro departamento de admisiones.',
      q5: '¿Cuál es el horario escolar?',
      a5: 'El horario regular es de lunes a jueves de 7:30 a.m. a 2:45 p.m. y los viernes de 7:30 a.m. a 2:05 p.m., con actividades extracurriculares hasta las 4:30 p.m.',
      q6: '¿Los estudiantes usan uniforme?',
      a6: 'Sí, tenemos un uniforme institucional que promueve la identidad y equidad dentro de la comunidad escolar.',
    },
    cta: {
      title: '¿Listo para dar el primer paso?',
      subtitle: 'Escríbenos o llámanos por WhatsApp para recibir información detallada sobre nuestros programas.',
      button: 'Solicitar Información por WhatsApp',
    },
    form: {
      badge: 'Solicitar Información',
      title: 'Solicita información sobre nuestros programas',
      subtitle: 'Completa el formulario y te contactaremos para brindarte toda la información que necesitas.',
      name: 'Nombre completo',
      email: 'Correo electrónico',
      phone: 'Teléfono',
      subject: 'Programa de interés',
      subjectPlaceholder: 'Selecciona un programa',
      message: 'Mensaje o consulta',
      submit: 'Solicitar información',
      sending: 'Enviando...',
      success: '¡Gracias! Tu solicitud ha sido enviada correctamente. Nos pondremos en contacto pronto.',
      error: 'Error al enviar. Por favor intenta de nuevo.',
      preschool: 'Preescolar',
      primary: 'Primaria',
      secondary: 'Secundaria',
      generalInfo: 'Información General',
    },
    whatsappMessage: 'Hola, me gustaría recibir información sobre los programas de San Lorenzo School',
  },
  contact: {
    title: 'Contacto',
    subtitle: 'Estamos aquí para responder todas tus preguntas. Contáctanos y te responderemos lo antes posible.',
    heroBadge: 'Estamos aquí',
    infoBadge: 'Información',
    address: 'Dirección',
    addressValue: 'Calle Principal, San Pedro, Montes de Oca, San José, Costa Rica',
    phone: 'Teléfono',
    phoneValue: '+506 8349 5115',
    email: 'Correo Electrónico',
    emailValue: 'admision@sanlorenzocr.com',
    hours: 'Horario de Atención',
    hoursValue: 'Lunes a Viernes: 8:00 a.m. - 4:00 p.m.',
    form: {
      title: 'Envíanos un mensaje',
      name: 'Nombre completo',
      email: 'Correo electrónico',
      phone: 'Teléfono',
      subject: 'Asunto',
      message: 'Mensaje',
      submit: 'Enviar mensaje',
      sending: 'Enviando...',
      success: '¡Gracias! Tu mensaje ha sido enviado correctamente.',
      error: 'Error al enviar. Por favor intenta de nuevo.',
    },
    visitaTab: 'Agendar Visita',
    contactoTab: 'Contacto',
    visita: {
      title: 'Agenda una visita a nuestro campus',
      preferredDate: 'Fecha preferida de visita',
      submit: 'Agendar visita',
      sending: 'Enviando...',
      success: '¡Gracias! Tu solicitud de visita ha sido enviada correctamente. Nos pondremos en contacto pronto.',
      error: 'Error al enviar. Por favor intenta de nuevo.',
    },
    followUs: 'Síguenos en redes sociales',
  },
  footer: {
    description: 'Aspira a lo más alto con humildad.',
    quickLinks: 'Enlaces Rápidos',
    programs: 'Programas',
    contact: 'Contacto',
    rights: 'Todos los derechos reservados.',
    privacy: 'Política de Privacidad',
    terms: 'Términos de Uso',
    address: 'San Pedro, Montes de Oca, San José, Costa Rica',
    hours: 'Lunes - Viernes, 8:00 AM - 4:00 PM',
    email: 'admision@sanlorenzocr.com',
  },
  whatsapp: {
    message: '¿Hola! Me gustaría recibir información sobre San Lorenzo School',
    helpBubble: '¿Necesitas ayuda?',
  },
  common: {
    learnMore: 'Conocer más',
    viewAll: 'Ver todo',
    back: 'Volver',
    next: 'Siguiente',
    previous: 'Anterior',
    galleryImage: 'Imagen de galería',
  },
};